import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-errormessagenew",
  templateUrl: "./errormessagenew.component.html",
  styleUrls: ["./errormessagenew.component.scss"]
})
export class ErrormessagenewComponent implements OnInit {
  guid: GUID;

  isLoading = false;
  isError = false;
  errorMessage = "";
  id = "";
  mode = "new";
  errorCodeList: any[] = [];
  actionForm = this.formBuilder.group({
    language: ["en"],
    title: [""],
    useraction: [""],
    type: [""],
    message: ["", Validators.required],
    errorcode: ["", Validators.required],
    name: ["", Validators.required],
    description: [""],
    active: [false],
    successmessage: [""]
  });
  languages = [
    { value: "en", label: "English" },
    { value: "ta", label: "Tamil" },
    { value: "ar", label: "Arabic" }
  ];
  types = [
    { value: "common", label: "Common" },
    { value: "tenant", label: "Tenant" }
  ];
  errorCategories: any[];
  errorMessageId: string;
  errorCodeId: string;
  errMessage: any;
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.guid = new GUID();
    // this.getErrorMessageCategory();
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.getAllErrorCode();
      this.mode = this.route.snapshot.params.mode;

      this.errorMessageId = this.route.snapshot.params.id;
    });
    if (this.mode.toLocaleLowerCase() == "edit") {
      this.actionForm.controls.type.disable();
      this.getErrorMessageById();
    }
    if (this.mode.toLocaleLowerCase() == "new") {
      this.actionForm.controls.type.enable();
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  cancel() {
    this.router.navigateByUrl("home/errormessagelist");
  }

  // getErrorMessageCategory() {
  //   return new Promise((resolve, reject) => {
  //     console.log("getErrorMessageCategory");

  //     // alert(id)
  //     const organizationid = localStorage.getItem("crm_orgid");
  //     // const domain = localStorage.getItem("domain");
  //     // const subdomain = localStorage.getItem("subdomain");
  //     const domain = localStorage.getItem(
  //       `${localStorage.getItem("crm_orgid")}.domain`
  //     );
  //     const subdomain = localStorage.getItem(
  //       `${localStorage.getItem("crm_orgid")}.subdomain`
  //     );
  //     this.isLoading = true;
  //     this.dataService.getErrorMessageCategory(domain, subdomain).subscribe(
  //       (res) => {
  //         console.log(res);
  //         if (res !== null && res.success == 1) {
  //           var msgCategories = res.data.errorcategory;
  //           var categoryArr = [];
  //           //just add an empty entry sice this field is optional
  //           // categoryArr.push({ value: "", label: "--None--" });
  //           for (let i = 0; i < msgCategories.length; i++) {
  //             var strLabel = msgCategories[i].categoryname;
  //             strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);

  //             categoryArr.push({
  //               value: msgCategories[i].id,
  //               label: strLabel
  //             });
  //           }
  //           this.errorCategories = categoryArr;

  //           this.isLoading = false;
  //           resolve(null);
  //         } else {
  //           console.log("No data!");
  //           this.errorMessage = res != null ? res.message : "No data!";
  //           this.isError = true;
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       },
  //       (err) => {
  //         console.log("Error***:", err);
  //         this.errorMessage = err.message;
  //         this.isError = true;
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //   });
  // }

  getErrorMessageById() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.errorMessageId;
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService.getErrorMessageById(domain, subdomain, id).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            this.errMessage = res.data.errormessage[0];
            console.log("Doneeee****", this.errMessage);

            if (this.errMessage != null) {
              // this.dataSource = this.crudmessages.map((item) => ({
              //   id: item.id,
              //   // label: item.labelname,
              //   message: item.message,
              //   operation: item.operation.charAt(0).toUpperCase() + item.operation.slice(1),
              //   language: item.languagecode,
              //   // modifiedby: item.modifiedby,
              //   // modifieddate: item.modifieddate,
              //   // type: item.organizationid,
              //   // type: item.organizationid ? item.organizationid : 'common',
              //   type: item.organizationid ? 'Tenant' : 'Common',
              //   // content: item.content,
              //   // metalayoutid: item.metalayoutid,
              // }));
              this.actionForm.controls["message"].setValue(
                this.errMessage.messagetemplate
              );
              this.actionForm.controls["language"].setValue(
                this.errMessage.languagecode
              );
              this.actionForm.controls["errorcode"].setValue(
                this.errMessage.errorcodeid
              );
              this.errorCodeId = this.errMessage.errorcode;

              this.actionForm.controls["title"].setValue(this.errMessage.title);
              this.actionForm.controls["useraction"].setValue(
                this.errMessage.useraction
              );
              if (this.errMessage.organizationid != null) {
                this.actionForm.controls["type"].setValue("tenant");
              } else {
                this.actionForm.controls["type"].setValue("common");
              }
            }
            console.log("Doneeee****", this.actionForm.controls["type"]);
            this.isLoading = false;
          } else {
            console.log("Error while saving");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getAllErrorCode() {
    console.log("getAllErrorCode called");

    const organizationid = localStorage.getItem("crm_orgid");

    const domain = localStorage.getItem(`${organizationid}.domain`);

    const subdomain = localStorage.getItem(`${organizationid}.subdomain`);

    this.isLoading = true;
    this.isError = false;

    this.dataService
      .getAllErrorCode(domain, subdomain, organizationid)
      .subscribe(
        (res: any) => {
          console.log("Full API Response:", res);

          if (res && res.success === 1 && res.data.errorcode) {
            const errorList = res.data.errorcode;

            // this.dataService = errorList.map((item: any) => ({
            //   id: item.id,
            //   errorcode: item.errorcode,
            //   httpstatus: item.httpstatus,
            //   message: item.message,
            //   severity: item.severity,
            //   loglevel: item.loglevel
            // }));
            this.errorCodeList = res.data.errorcode.map((item: any) => ({
              value: item.id, // 👉 id save ஆகும்
              label: item.errorcode // 👉 UIல error code மட்டும் காட்டும்
            }));

            console.log("Mapped DataService:", this.errorCodeList);
          } else {
            this.isError = true;
            this.errorMessage = "No data found";
          }

          this.isLoading = false;
        },
        (err) => {
          console.error("API Error:", err);
          this.isError = true;
          this.errorMessage = err.message || "Something went wrong";
          this.isLoading = false;
        }
      );
  }

  save() {
    if (this.actionForm.controls["message"].value.toString().trim() == "") {
      this.showWarning("Message is mandatory");
      return;
    }
    if (this.actionForm.controls["errorcode"].value.toString().trim() == "") {
      this.showWarning("Message errorcode is mandatory");
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      if (
        this.actionForm.controls["type"].value.toLocaleLowerCase() == "common"
      ) {
        this.errorMessageId = this.guid.getGUID("commonerrormessage");
      } else if (
        this.actionForm.controls["type"].value.toLocaleLowerCase() == "tenant"
      ) {
        this.errorMessageId = this.guid.getGUID("tenanterrormessage");
      }
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      // profileid: userDetail.profileid,
      // profilename: userDetail.profilename,
      data: {
        errormessage: {
          id: this.errorMessageId,
          mode: this.mode,
          messagetemplate: this.actionForm.controls["message"].value.trim(),
          languagecode: this.actionForm.controls["language"].value.trim(),
          type: this.actionForm.controls["type"].value.trim(),
          title: this.actionForm.controls["title"].value.trim(),
          useraction: this.actionForm.controls["useraction"].value.trim(),
          // errorcode: this.actionForm.controls["errorcode"].value.trim(),
          errorcodeid: this.actionForm.controls["errorcode"].value
        }
      }
    };

    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertErrorMessage(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/errormessagelist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
